import React from "react";
import { FormBuilder, Form, ModalBuilder, Modal } from "@redriver/cinnamon";
import { Popup, Icon, Button } from "semantic-ui-react";
const ConfigField = ({
  item,
  type,
  canEdit,
  onSubmitted,
  updatedDateTime,
  submitAction,
}) => (
  <FormBuilder
    initialReadOnly={!canEdit}
    key={`${item.key}${updatedDateTime}`}
    onLoad={() => ({ ...item })}
    onSubmitted={onSubmitted}
    renderForm={(formProps, formState, formEvents) => (
      <Form {...formProps}>
        <div className="system-config-item">
          <Form.Input
            field="value"
            label={
              <div className="label">
                <label>{formProps.value.label}</label>
              </div>
            }
            width={28}
            disabled={formProps.disabled || item.preventManualUpdate}
          />
          <Popup
            content={formProps.value.description}
            trigger={<Icon name="help circle" />}
          />

          {canEdit && (
            <React.Fragment>
              <Button
                compact
                content="Cancel"
                onClick={() => formEvents.onRefresh()}
                disabled={!formState.dirty || formState.submitting}
                loading={formState.submitting}
              />
              <ModalBuilder
                submitAction={submitAction}
                submitParams={{
                  item: formProps.value,
                  type,
                }}
                onSubmitted={onSubmitted}
                renderTrigger={(showModal) => (
                  <Button
                    primary
                    compact
                    content="Save"
                    onClick={showModal}
                    disabled={!formState.dirty || formState.submitting}
                    loading={formState.submitting}
                  />
                )}
                renderModal={(modalProps) => (
                  <Modal.Confirmation {...modalProps}>
                    <p>Are you sure you want to change this setting?</p>
                  </Modal.Confirmation>
                )}
              />
            </React.Fragment>
          )}
        </div>
      </Form>
    )}
  />
);

export default ConfigField;
